// extracted by mini-css-extract-plugin
module.exports = {"iconInCircle":"styles_iconInCircle__3xs3d","cursorPointer":"styles_cursorPointer__3H4Pw","isNotification":"styles_isNotification__2jkiC"};